import { render, staticRenderFns } from "./BanEdit.vue?vue&type=template&id=466cc908&"
import script from "./BanEdit.vue?vue&type=script&lang=js&"
export * from "./BanEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports